import { css } from "styled-components";

const ellipsis = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  overflow: hidden;
`;

export default ellipsis;
